import { axiosInstance } from 'api/apiConfig'
import { useQuery, useMutation } from 'react-query'

const postCommonLikeList = async (target, params) => {
  const { data } = await axiosInstance.post('api/like/v1.0' + (target ? '/' + target : ''), params)
  return data
}

// 좋아요 조회
export const useLikeCount = (params, isInit) => {
  return useQuery(['likeGet'], () => postCommonLikeList('', params), {
    enabled: isInit,
  })
}

// 좋아요 등록
export const useLikeInsert = ({ successHandler, errorHandler }) => {
  return useMutation((params) => postCommonLikeList('insert', params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}

// 좋아요 취소
export const useLikeDelete = ({ successHandler, errorHandler }) => {
  return useMutation((params) => postCommonLikeList('delete', params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}
